import { Outlet } from "react-router-dom";
import { useNotificationRealtime } from "@facade/features/notifications";
import { JobExperience } from "@facade/features/jobs";

export const Layout = () => {
  useNotificationRealtime();

  return (
    <div className="flex h-screen min-h-0 flex-col">
      <div className="min-h-0 flex-1 overflow-auto">
        <div className="m-auto flex h-full flex-col items-center">
          <Outlet />
        </div>
      </div>
      <JobExperience />
    </div>
  );
};
